"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Vermin = void 0;
const Card_1 = require("../Card");
const CardType_1 = require("../CardType");
const CardName_1 = require("../../CardName");
const CardRenderer_1 = require("../render/CardRenderer");
const Tags_1 = require("../Tags");
const Size_1 = require("../render/Size");
const CardRenderDynamicVictoryPoints_1 = require("../render/CardRenderDynamicVictoryPoints");
const ResourceType_1 = require("../../ResourceType");
const Board_1 = require("../../boards/Board");
const DeferredAction_1 = require("../../deferredActions/DeferredAction");
const SelectCard_1 = require("../../inputs/SelectCard");
const OrOptions_1 = require("../../inputs/OrOptions");
const SelectOption_1 = require("../../inputs/SelectOption");
class Vermin extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.ACTIVE,
            name: CardName_1.CardName.VERMIN,
            tags: [Tags_1.Tags.MICROBE, Tags_1.Tags.ANIMAL],
            cost: 8,
            resourceType: ResourceType_1.ResourceType.ANIMAL,
            metadata: {
                cardNumber: 'X75',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.effect(undefined, (eb) => {
                        eb.city(Size_1.Size.SMALL).any.startEffect.animals(1);
                    }).br;
                    b.action(undefined, (eb) => {
                        eb.empty().startAction.animals(1).or().microbes(1).asterix();
                    }).br;
                    b.text('(Effect: When any city is placed, add 1 animal here. Action: Add 1 animal here, or add 1 microbe to ANOTHER card.)', Size_1.Size.SMALL, false, false);
                }),
                description: 'Each player, including you, gets -1 VP per city they have IF THERE ARE AT LEAST 10 ANIMALS HERE.',
                victoryPoints: CardRenderDynamicVictoryPoints_1.CardRenderDynamicVictoryPoints.vermin(),
            },
        });
        this.resourceCount = 0;
    }
    play() {
        return undefined;
    }
    onTilePlaced(cardOwner, activePlayer, space) {
        if (Board_1.Board.isCitySpace(space)) {
            cardOwner.game.defer(new DeferredAction_1.DeferredAction(cardOwner, () => {
                cardOwner.addResourceTo(this, { log: true });
                return undefined;
            }), cardOwner.id !== activePlayer.id ? DeferredAction_1.Priority.OPPONENT_TRIGGER : undefined);
        }
    }
    canAct() {
        return true;
    }
    action(player) {
        const microbeCards = player.getResourceCards(ResourceType_1.ResourceType.MICROBE);
        if (microbeCards.length === 0) {
            player.addResourceTo(this, { log: true });
            return undefined;
        }
        const addAnimalOption = new SelectOption_1.SelectOption('Add 1 animal here', 'Select', () => {
            player.addResourceTo(this, { log: true });
            return undefined;
        });
        if (microbeCards.length === 1) {
            return new OrOptions_1.OrOptions(addAnimalOption, new SelectOption_1.SelectOption(`Add 1 microbe to ${microbeCards[0].name}`, 'Select', () => {
                player.addResourceTo(microbeCards[0], { qty: 1, log: true });
                return undefined;
            }));
        }
        return new OrOptions_1.OrOptions(addAnimalOption, new SelectOption_1.SelectOption('Add 1 microbe to another card', 'Select', () => {
            return new SelectCard_1.SelectCard('Select card to add 1 microbe', 'Add microbe', microbeCards, (foundCards) => {
                player.addResourceTo(foundCards[0], { log: true });
                return undefined;
            });
        }));
    }
}
exports.Vermin = Vermin;
//# sourceMappingURL=Vermin.js.map